import styled from 'styled-components'

/**
 * Styled components for better question/answer presentation
 */

export const QuestionCard = styled.div`
  background: ${(props) => 
    props.$hasAnswer 
      ? 'rgba(16, 185, 129, 0.05)' 
      : 'rgba(241, 245, 249, 0.5)'};
  border: 1px solid ${(props) => 
    props.$hasAnswer 
      ? 'rgba(16, 185, 129, 0.2)' 
      : 'rgba(203, 213, 225, 0.3)'};
  border-left: 3px solid ${(props) => 
    props.$hasAnswer 
      ? '#10b981' 
      : '#cbd5e1'};
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 10px;
  transition: all 0.2s ease;
  position: relative;
  
  /* Print styles - preserve colors */
  @media print {
    page-break-inside: avoid;
    margin-bottom: 8px;
    padding: 8px 12px;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  /* Screen only - hover effect */
  @media screen {
    &:hover {
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    }
  }
`

export const QuestionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 0;
`

export const QuestionNumber = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${(props) => 
    props.$hasAnswer 
      ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' 
      : 'linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%)'};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  
  @media print {
    width: 22px;
    height: 22px;
    font-size: 11px;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const QuestionTextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0; /* Allow flex shrinking */
`

export const QuestionText = styled.div`
  font-weight: 600;
  font-size: 13px;
  color: #1e293b;
  line-height: 1.4;
  display: inline;
  
  @media print {
    font-size: 12px;
  }
`

export const QuestionTranslation = styled.div`
  font-size: 12px;
  color: #64748b;
  font-style: italic;
  margin-top: 3px;
  
  @media print {
    font-size: 11px;
  }
`

export const AnswerContainer = styled.div`
  margin-top: 8px;
  padding: 8px 12px;
  background: ${(props) => 
    props.$hasAnswer 
      ? 'rgba(255, 255, 255, 0.8)' 
      : 'rgba(241, 245, 249, 0.8)'};
  border-radius: 6px;
  border-left: 2px solid ${(props) => 
    props.$hasAnswer 
      ? '#10b981' 
      : '#cbd5e1'};
  
  @media print {
    padding: 6px 10px;
    margin-top: 6px;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AnswerLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  
  @media print {
    font-size: 10px;
  }
`

export const AnswerText = styled.div`
  font-size: 13px;
  color: #334155;
  line-height: 1.5;
  white-space: pre-wrap;
  display: flex;
  align-items: center;
  gap: 6px;
  
  @media print {
    font-size: 12px;
  }
`

export const YesNoIndicator = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${(props) => props.$isYes ? '#10b981' : '#ef4444'};
  
  @media print {
    font-size: 14px;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AdditionalResponse = styled.div`
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(203, 213, 225, 0.5);
  font-size: 12px;
  color: #475569;
  font-style: italic;
  line-height: 1.5;
  white-space: pre-wrap;
  
  @media print {
    font-size: 11px;
    margin-top: 6px;
    padding-top: 6px;
  }
`

export const StatusBadge = styled.span`
  position: absolute;
  top: 8px;
  right: 10px;
  padding: 3px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: ${(props) => 
    props.$hasAnswer 
      ? 'rgba(16, 185, 129, 0.15)' 
      : 'rgba(148, 163, 184, 0.15)'};
  color: ${(props) => 
    props.$hasAnswer 
      ? '#059669' 
      : '#64748b'};
  border: 1px solid ${(props) => 
    props.$hasAnswer 
      ? 'rgba(16, 185, 129, 0.3)' 
      : 'rgba(148, 163, 184, 0.3)'};
  
  @media print {
    display: none;
  }
`

